import script from "./StickyBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./StickyBar.vue?vue&type=script&lang=ts&setup=true"

import "./StickyBar.vue?vue&type=style&index=0&id=09c7d935&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1683583046/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09c7d935"]])

export default __exports__